import { useDispatch, useSelector } from 'react-redux';
import { injectionRowHeaderMapping } from '../../../../../../../../constants';
import { FlatInjectionObj } from '../../../../../../../../store/types/prescription';
import { INJECTION_COLUMN } from '../../../../../../../../utils/enums';
import { generateDurationOptions } from '../../../../../../../common/optionGeneratorUtils';
import AntAutoCompleteV2 from '../../../AntAutoComplete';
import { EditableCellV2 } from '../../../MedTableRenderer';
import { INJECTION_TABLE_ID, INJECTIONS_TABLE_CONTAINER } from '../InjectionTable';
import { getInjectionElements } from '../../../../../../../../store/selectors/prescriptionPad';
import {
    setInjectionElements,
    upsertInjection,
} from '../../../../../../../../store/actions/prescriptionPad';
import CopyToAll from '../../../CopyToAll';

const InjectionDuration = ({
    injection,
    columnKey,
    isDragMode,
}: {
    injection: FlatInjectionObj;
    columnKey: INJECTION_COLUMN;
    isDragMode: boolean;
}): JSX.Element => {
    const elements = useSelector(getInjectionElements);
    const dispatch = useDispatch();
    const showCopyAllChip =
        (injection.is_last_drug && injection.is_last_tapering) ||
        (injection.added_drug && injection.added_drug.length > 0) ||
        (injection.tapering_dose && injection.tapering_dose.length > 0);

    const onDurationSearch = (
        value: string,
    ): Promise<{ id: string; label: string; value: string; meta: any }[]> => {
        return new Promise((resolve, _) => {
            resolve(generateDurationOptions(value));
        });
    };
    const onDurationSelect = (value: string) => {
        const { is_added_drug, is_tapering_dose, currentIndex, mainIndex } = injection;
        const clonedElement = elements[mainIndex];
        if (is_added_drug) {
            if (clonedElement.added_drug?.[currentIndex]) {
                clonedElement.added_drug[currentIndex].duration = {
                    ...(clonedElement.added_drug[currentIndex].duration || {}),
                    custom: value,
                };
            }
        } else if (is_tapering_dose) {
            if (clonedElement.tapering_dose?.[currentIndex]) {
                clonedElement.tapering_dose[currentIndex].duration = {
                    ...(clonedElement.tapering_dose[currentIndex].duration || {}),
                    custom: value,
                };
            }
        } else {
            if (clonedElement) {
                clonedElement.duration = {
                    ...(clonedElement.duration || {}),
                    custom: value,
                };
            }
        }
        dispatch(upsertInjection(clonedElement, mainIndex));
    };
    const onCopyToAllClick = () => {
        const { duration } = injection;
        const clonedElements = [...elements];
        clonedElements.forEach((element) => {
            element.duration = duration;
        });
        clonedElements.forEach((element) => {
            element.tapering_dose?.forEach((taperDose) => {
                taperDose.duration = duration;
            });
        });
        dispatch(setInjectionElements(clonedElements));
    };

    return isDragMode && (injection.is_added_drug || injection.is_tapering_dose) ? (
        <></>
    ) : (
        <div className="flex flex-col">
            <EditableCellV2
                defaultValue={injection?.duration?.custom}
                label={injectionRowHeaderMapping[columnKey]}
            >
                <AntAutoCompleteV2
                    autoFocus
                    onSearch={onDurationSearch}
                    selectedValue={{
                        label: injection?.duration?.custom || '',
                        value: injection?.duration?.custom || '',
                        id: injection?.duration?.custom || '',
                        meta: {},
                    }}
                    debounceDelay={200}
                    getLabelToCompare={(o) => o.label}
                    placeholder={'Duration'}
                    customDropdownWidth={180}
                    onSelect={(option) => {
                        onDurationSelect(option?.label as string);
                    }}
                    containerIdToAttachDropdown={INJECTIONS_TABLE_CONTAINER}
                    key={`Injection-${columnKey}`}
                />
            </EditableCellV2>
            {showCopyAllChip ? (
                <CopyToAll
                    id={`injection-duration-${injection.mainIndex}`}
                    tableId={INJECTION_TABLE_ID}
                    onClick={onCopyToAllClick}
                />
            ) : null}
        </div>
    );
};

export default InjectionDuration;
